import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { theme } from "./theme/theme";
import { Layout } from "./layout/Layout";
import {DashboardPage} from "./component/DashboardPage";
import {ImageToPdfPage} from "./component/ImageToPdfPage";
import {PdfMergePage} from "./component/PdfMergePage";
import {PdfCompressPage} from "./component/PdfCompressPage";
import {PdfEditPage} from "./component/PdfEditPage";
import {FeedbackPage} from "./component/FeedbackPage";
import {KanbanPage} from "./component/KanbanPage";
import {ApiDocsPage} from "./component/ApiDocsPage";
import {DonatePage} from "./component/DonatePage";


function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <BrowserRouter>
                <Layout>
                    <Routes>
                        <Route path="/" element={<DashboardPage />} />
                        <Route path="/image-to-pdf" element={<ImageToPdfPage />} />
                        <Route path="/merge" element={<PdfMergePage />} />
                        <Route path="/compress" element={<PdfCompressPage />} />
                        <Route path="/edit" element={<PdfEditPage />} />
                        <Route path="/feedback" element={<FeedbackPage />} />
                        <Route path="/kanban" element={<KanbanPage />} />
                        <Route path="/api-docs" element={<ApiDocsPage />} />
                        <Route path="/donate" element={<DonatePage />} />
                    </Routes>
                </Layout>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
